var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"value":_vm.value,"data-test":"search","outlined":"","dense":"","hide-details":"auto","label":_vm.placeholder || '',"prepend-inner-icon":"mdi-magnify"},on:{"input":_vm.emitValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }